export default __webpack_public_path__ + "static/media/chrysler.0a6b95a4.png";